@import '../../scss/mixin';

.thread {
  display: flex;
  flex-direction: column;
  row-gap: size(15);
  min-height: calc(100vh - 100px);
  background: var(--llm-color-background);
  color: var(--llm-color-foreground);
}

.message {
  position: relative;
  display: flex;
  flex-direction: column;
}

.messageInner {
  max-width: 100%;
  overflow: hidden;
}
